import React from 'react';

import { Button } from '@rbilabs/components-library';

import {
  StyledBody,
  StyledDialog,
  StyledHeader,
  StyledPicture,
  StyledTextOnlyButton,
} from './actions-modal.styled';
import { IActionsModalProps } from './types';

const ActionsModal = ({
  actions,
  bodyText,
  'data-testid': dataTestId,
  headerText,
  image,
  imageAlt = '',
  modalAppearanceEventMessage,
}: IActionsModalProps) => {
  const Header = () => <StyledHeader>{headerText}</StyledHeader>;
  const Body = () => <StyledBody>{bodyText}</StyledBody>;
  const Actions = () => (
    <>
      {actions.map(
        ({ dataTestId: actionDataTestId, actionLabel, actionHandler, textOnly = false }) => {
          const BtnComponent = textOnly ? StyledTextOnlyButton : Button;
          return (
            <BtnComponent key={actionLabel} data-testid={actionDataTestId} onClick={actionHandler}>
              {actionLabel}
            </BtnComponent>
          );
        }
      )}
    </>
  );

  return (
    <StyledDialog
      data-testid={dataTestId}
      headingComponent={<Header />}
      image={!!image && <StyledPicture image={image} alt={imageAlt} />}
      bodyComponent={<Body />}
      actions={<Actions />}
      modalAppearanceEventMessage={modalAppearanceEventMessage}
    />
  );
};

export default ActionsModal;
